module.exports = __webpack_public_path__ + "static/ThePokeCo-fbe290c0589ae7a3cf0706c02a10e497.png";